import { Button, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { Card } from '../../shared'
import { SIGNAL_HEADINGS, type SignalCategory, type UnionSignalCounts } from '../../../types/unionSignals'

// O2 Union Signals: dashboard summary of what canvassers reported at the door, linking to the queue.

const ROWS: { category: SignalCategory; key: keyof UnionSignalCounts }[] = [
  { category: 'DoesntWorkHere', key: 'doesntWorkHere' },
  { category: 'DoesntLiveHere', key: 'doesntLiveHere' },
  { category: 'MissingMember', key: 'missingMember' },
  { category: 'RecruitmentLead', key: 'recruitmentLead' },
]

export function UnionSignalsCard({
  campaignId,
  counts,
}: {
  campaignId: string
  counts: UnionSignalCounts | null | undefined
}) {
  if (!counts) return null
  const total = ROWS.reduce((sum, r) => sum + counts[r.key], 0)

  return (
    <Card>
      <VStack align="stretch" gap={3}>
        <Heading size="sm">Union signals</Heading>
        {ROWS.map((r) => (
          <HStack key={r.category} justify="space-between">
            <Text color={counts[r.key] > 0 ? 'fg' : 'fg.muted'}>{SIGNAL_HEADINGS[r.category]}</Text>
            <Text fontWeight="medium" color={counts[r.key] > 0 ? 'fg' : 'fg.muted'}>
              {counts[r.key]}
            </Text>
          </HStack>
        ))}
        {total === 0 && <Text color="fg.muted">Nothing to review</Text>}
        <Button asChild variant="outline" minH="44px" alignSelf="flex-start">
          <Link to={`/dashboard/campaigns/${campaignId}/signals`}>Review signals</Link>
        </Button>
      </VStack>
    </Card>
  )
}
